import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=484bf673&scoped=true&"
import script from "./preview.vue?vue&type=script&lang=js&"
export * from "./preview.vue?vue&type=script&lang=js&"
import style0 from "./preview.vue?vue&type=style&index=0&lang=css&"
import style1 from "./preview.vue?vue&type=style&index=1&id=484bf673&lang=less&scoped=true&"
import style2 from "./preview.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484bf673",
  null
  
)

export default component.exports